export enum ElasticSearchVariations {
  AWS_ELASTICSEARCH = 'AWS_ELASTICSEARCH',
  AWS_OPENSEARCH = 'AWS_OPENSEARCH'
}
